var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.49999C0 3.25147 0.356349 3.04999 0.795918 3.04999H10.1209L6.63256 1.28536C6.30497 1.11964 6.27702 0.835159 6.57011 0.649946C6.86323 0.464732 7.36639 0.448928 7.69398 0.614648L12.7348 3.16464C12.9035 3.25 13 3.37197 13 3.49999C13 3.62802 12.9035 3.74999 12.7348 3.83535L7.69398 6.38534C7.36639 6.55106 6.86323 6.53528 6.57011 6.35006C6.27702 6.16484 6.30497 5.88032 6.63256 5.7146L10.1209 3.94999H0.795918C0.356349 3.94999 0 3.74852 0 3.49999Z",
    fill: "#7A7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowIcon);
export default __webpack_public_path__ + "static/media/right-arrow-icon.70a724cb10afb86e4838701860dbee2e.svg";
export { ForwardRef as ReactComponent };